import { Normalization } from '~/utils/normalization'
import type { AppEnv } from '~~/env.schema'

// APP_ENV, not NODE_ENV: every deployed tier builds as production.
const ENGINEERING_ENVIRONMENTS = [
  'local',
  'testing',
  'development',
  'qa'
] as const satisfies readonly AppEnv[]

/** Whether the deployed environment is one where engineering aids (diagnostics, test assists) are allowed. */
export function isEngineeringEnvironment(): boolean {
  const appEnv = Normalization.trimmedStringValue(useRuntimeConfig().public.appEnv)
  return ENGINEERING_ENVIRONMENTS.some((environment) => environment === appEnv)
}
